module.exports = __webpack_public_path__ + "img/credential-5.fdfc0e54.png";